import { createSlice } from "@reduxjs/toolkit";

const globalSlice = createSlice({
	name: "global",
	initialState: {
		loading: false,
		screenTitle: "loading...",
		appType: null,
		showFormHeader: false,
		homePath: null, //must start null, because upon signin we check if it is null to determine default path
		appId: null,
		formDefinitionId: null,
		orgRootId: null,
		domain: null,
		showFooter: true,
		showHeader: true,
	},
	reducers: {
		loadingEdited(state, action) {
			state.loading = action.payload;
		},
		globalEdited(state, action) {
			for (const [key, value] of Object.entries(action.payload)) {
				state[key] = value;
			}
		},
		homePathEdited(state, action) {
			state.homePath = action.payload;
		},
		screenTitleEdited(state, action) {
			state.screenTitle = action.payload;
		},
	},
	extraReducers: {},
});

export const {
	loadingEdited,
	globalEdited,
	homePathEdited,
	screenTitleEdited,
} = globalSlice.actions;

export const selectGlobal = (state) => state.global;

export const selectGlobalLoading = (state) => state.global.loading;

export const selectGlobalScreenTitle = (state) => state.global.screenTitle;

export default globalSlice.reducer;
